<template>

  <div class="content">
    <div class="container-fluid">
         <div
      class="d-flex justify-content-between align-items-center mb-4 bg-white p-3 border border-gray shadow-xs rounded w-100"
    >
      <div>
                <router-link :to="{ path: '/races'}">
          <button type="submit" class="btn btn-warning btn-sm px-3 mr-3">Yarışlar</button>
        </router-link>
        <router-link :to="{ path: '/seasons'}">
          <button type="submit" class="btn btn-info  btn-sm px-3 mr-3">Sezonlar</button>
        </router-link>

        <router-link :to="{ path: '/members'}">
          <button type="submit" class="btn btn-danger active btn-sm px-3 mr-3">Üyeler</button>
        </router-link>

      </div>
      <span></span>
    </div>

      <card>
        <div>
          <table class="table table-hover table-striped table-bordered mb-0">
            <thead class="thead-dark">
              <th>Ad Soyad</th>
              <th>Branş</th>
              <th>Kategori</th>
              <th>Opsiyonel Kategori</th>
              <th>Doğum Tarihi</th>
              <th>Cinsiyet</th>
              <th>Telefon No</th>
              <th>Kimlik No</th>
              <th>Lisans</th>
              <!--<th>HES Kodu</th>-->
            </thead>
            <tbody>
              <tr v-for="(athletes,key) in user.athletes" :key="key">
                <td>{{athletes.name}} {{athletes.surname}}</td>
                <td>{{athletes.branch}}</td>
                <td>{{athletes.category}}</td>
                <td>
                  <span v-if="athletes.optionalCategory">{{athletes.optionalCategory}}</span>
                  <span v-if="!athletes.optionalCategory">Seçilmedi</span>
                </td>
                <td>{{athletes.birthdate}}</td>
                <td>{{athletes.gender}}</td>
                <td>{{athletes.phone}}</td>
                <td>{{athletes.tc}}</td>
                <td>
                  <a
                    v-if="athletes.license"
                    class="ml-3"
                    :href="license(athletes.license)"
                    target="_blank"
                  >Lisans Aç</a>
                </td>
                <!--<td>
                  <a
                    v-if="athletes.hes"
                    class="ml-3"
                    :href="hes(athletes.hes)"
                    target="_blank"
                  >Hes Aç</a>
                </td>-->
              </tr>
            </tbody>
          </table>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import Card from "src/components/UIComponents/Cards/Card.vue";
import Checkbox from "src/components/UIComponents/Inputs/Checkbox.vue";
export default {
  data: function() {
    return {
      isEdit: false,
      user: {
        user_type_id: null,
        name: null,
        surname: null,
        tcno: null,
        email: null,
        password: null,
        profile_photo: null,
        url: "nourl",
        authkey: "nokey",
        recoverytoken: null,
        lastrecovery: null,
        is_active: 1
      },
      passwordRepeat: null,
      userTypes: null,
      errors: [],
      image: {
        cropped: null
      },
      imageRecreated: false,
      croppieType: "main",
      // end of post data
      options: {
        language_url: "/static/plugins/tinymce-lang/tr.js",
        height: 300
      },
      branches: {
        0: "Senkronize Buz Pateni",
        1: "Artistik Buz Pateni",
        2: "Short Track"
      },
      categories: {
        0: {
          0: "Pre-Juvenile",
          1: "Juvenile",
          2: "Basic Novice",
          3: "Advanced Novice",
          4: "Mixed Age 1",
          5: "Senior Elite 12",
          6: "Mixed Age 3",
          7: "Junior",
          8: "Senior"
        },
        1: {
          0: "Senior",
          1: "Junior",
          2: "Advanced Novice",
          3: "Intermediate Novice",
          4: "Basic Novice 1",
          5: "Basic Novice 2",
          6: "Pre-Novice",
          7: "Cubs 1",
          8: "Cubs 2",
          9: "Chicks 1",
          10: "Chicks 2"
        },
        2: {
          0: "Mix",
          1: "Senior",
          2: "Junior A",
          3: "Junior B",
          4: "Junior C",
          5: "Junior D",
          6: "Junior E",
          7: "Junior F",
          8: "Junior G"
        },
        3: {
          0: "1. Grup",
          1: "2. Grup",
          2: "3. Grup",
          3: "4. Grup"
        },
        4: {
          0: "1. Grup",
          1: "2. Grup",
          2: "3. Grup"
        }
      },
      genders: {
        0: "Kadın",
        1: "Erkek"
      }
    };
  },
  components: {
    Checkbox,
    Card
  },
  methods: {
    setUrl: function(data, path) {
      return this.raceURL() + data + path;
    },
    license: function(data) {
      return this.licenseURL() + data;
    },
    hes: function(data) {
      return this.hesURL() + data;
    },
    checkForm: function() {
      this.errors = [];
      if (!this.user.name) {
        this.errors.push("Ad Alanı Boş");
      }
      if (!this.user.surname) {
        this.errors.push("Soyad Alanı Boş");
      }
      if (!this.user.email) {
        this.errors.push("E-Posta Alanı Boş");
      }
      if (!this.isEdit) {
        if (!this.user.password) {
          this.errors.push("Şifre Alanı Boş");
        }
      }
      if (!this.isEdit) {
        if (this.user.password !== this.passwordRepeat) {
          this.errors.push("Şifreler Birbiriyle Eşleşmedi");
        }
      } else {
        if (
          this.user.password !== this.passwordRepeat &&
          ("password" in this.user && this.user.password !== "")
        ) {
          this.errors.push("Şifreler Birbiriyle Eşleşmedi");
        }
      }
      if (!this.validEmail(this.user.email)) {
        this.errors.push("E-Posta Formatı Doğru Değil");
      }
      if (!this.errors.length) {
        this.saveImage();
      }
    },
    validEmail: function(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    saveImage: function() {
      this.toggleLoader();
      if (this.imageRecreated) {
        this.$http.post("/api/images/upload/" + this.user.url, this.image).then(
          response => {
            this.user.profile_photo = response.body.Data.Response.name;
            if (this.isEdit) {
              this.updateUser();
            } else {
              this.saveUser();
            }
          },
          e => {
            button.innerHTML = "Kaydet";
            this.notifier("top", "right", "danger", "Bir Hata Oluştu");
            this.toggleLoader();
          }
        );
      } else {
        if (this.isEdit) {
          this.updateUser();
        } else {
          this.saveUser();
        }
      }
    },
    saveUser: function() {
      this.$http.post("/api/users/add", this.user).then(
        response => {
          this.notifier("top", "right", "success", "Başarılı");
          if (this.$route.params.type === "member") {
            this.$router.push("/members");
          } else {
            this.$router.push("/users");
          }
          this.toggleLoader();
        },
        e => {
          this.notifier("top", "right", "danger", "Bir Hata Oluştu");
          this.toggleLoader();
        }
      );
    },
    updateUser: function() {
      if (this.user.password === "") {
        delete this.user.password;
      }
      this.user.url = this.user.url + "-" + this.user.id;
      this.$http.post("/api/users/edit/" + this.user.id, this.user).then(
        response => {
          this.notifier("top", "right", "success", "Başarılı");
          if (this.$route.params.type === "member") {
            this.$router.push("/members");
          } else {
            this.$router.push("/users");
          }
          this.toggleLoader();
        },
        e => {
          this.notifier("top", "right", "danger", "Bir Hata Oluştu");
          this.toggleLoader();
        }
      );
    },
    initiateCroppie(type) {
      this.croppieType = type;
    },
    bind() {
      var oFReader = new FileReader();
      if (document.getElementById("myImage").files.length) {
        oFReader.readAsDataURL(document.getElementById("myImage").files[0]);
        var refz = this.$refs;
        oFReader.onload = function(oFREvent) {
          refz.main.bind({
            url: oFREvent.target.result
          });
        };
      }
    },
    crop() {
      var dis = this;
      return new Promise(resolve => {
        let options = {
          format: "jpeg",
          size: {
            width: 800,
            height: 800
          },
          quality: 1
        };
        dis.$refs.main.result(options, output => {
          if (this.croppieType === "main") {
            dis.image.cropped = output;
            dis.imageRecreated = true;
          } else if (this.croppieType === "slider") {
            dis.sliderimage.cropped = output;
            dis.sliderImageLoaded = true;
          }
          this.hideCroppieModal();
          dis.$refs.main.refresh();
          resolve(output);
        });
      });
    },
    hideCroppieModal() {
      this.$root.$emit("bv::hide::modal", "croppieModal");
    },
    result(output) {
      return output;
    }
  },
  mounted: function() {
    this.$nextTick(function() {
      this.toggleLoader();
      this.$http.get("/api/user-types/all").then(
        response => {
          this.userTypes = response.body;
          if (this.$route.params.id) {
            this.$http
              .get("/api/users/get-without-joins/" + this.$route.params.id)
              .then(
                response => {
                  this.isEdit = true;
                  this.user = response.body;
                  this.user.athletes = JSON.parse(this.user.athletes);
                  this.user.athletes.forEach(e => {
                    e.category = this.categories[e.branch][e.category];
                    e.branch = this.branches[e.branch];
                    e.gender = this.genders[e.gender];
                  });
                  this.image.cropped =
                    this.mediaURL() + this.user.profile_photo;
                  this.toggleLoader();
                },
                response => {
                  this.notifier(
                    "top",
                    "right",
                    "danger",
                    "Bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz."
                  );
                  this.toggleLoader();
                }
              );
          } else {
            this.toggleLoader();
          }
        },
        er => {
          this.toggleLoader();
          this.notifier(
            "top",
            "right",
            "danger",
            "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz."
          );
        }
      );
    });
  }
};
</script>
  <style>
.input-group-text.is-valid {
  border-color: #28a745 !important;
}
.input-group-text {
  transition: 300ms;
}
.input-group-text.is-invalid {
  border-color: #dc3545 !important;
  background-color: #dc3545;
  color: #fff;
}
.form-check-label {
  font-size: 16px !important;
  line-height: 15px !important;
  text-transform: capitalize !important;
}
.seo-text {
  background-color: #e9ecef;
  border: 1px solid #ced4da;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/MemberModules/MemberAthletes.vue